<script lang="ts">
  export let countryCode: string;
</script>

{#if countryCode === "bd"}
  <svg class="flag" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512" fill="none">
    <path
      d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
      fill="#496E2D"/>
    <path
      d="M200.348 367.304C261.82 367.304 311.652 317.472 311.652 256C311.652 194.529 261.82 144.696 200.348 144.696C138.877 144.696 89.044 194.529 89.044 256C89.044 317.472 138.877 367.304 200.348 367.304Z"
      fill="#D80027"/>
  </svg>
{:else if countryCode === "kh"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 256C0 300.35 11.283 342.064 31.127 378.435L256 400.696L480.873 378.435C500.717 342.064 512 300.35 512 256C512 211.65 500.717 169.936 480.873 133.565L256 111.304L31.127 133.565C11.283 169.936 0 211.65 0 256H0Z"
      fill="#D80027"/>
    <path d="M31.127 133.565H480.872C437.454 53.989 353.035 0 256 0C158.965 0 74.546 53.989 31.127 133.565Z"
          fill="#0052B4"/>
    <path d="M256 512C353.035 512 437.454 458.011 480.873 378.435H31.127C74.546 458.011 158.965 512 256 512Z"
          fill="#0052B4"/>
    <path
      d="M345.043 306.087V272.696H322.783V228.174L300.522 205.913L278.261 228.174V183.652L256 161.391L233.739 183.652V228.174L211.478 205.913L189.217 228.174V272.696H166.957V306.087H144.696V339.478H367.304V306.087H345.043Z"
      fill="#F0F0F0"/>
  </svg>
{:else if countryCode === "cn"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
      fill="#D80027"/>
    <path
      d="M140.1 155.8L162.2 223.8H233.7L175.9 265.9L198 333.9L140.1 291.9L82.2 333.9L104.4 265.9L46.5 223.8H118L140.1 155.8Z"
      fill="#FFDA44"/>
    <path
      d="M303.5 396.5L286.6 375.7L261.6 385.4L276.1 362.9L259.2 342L285.1 348.9L299.7 326.4L301.1 353.2L327.1 360.1L302 369.7L303.5 396.5Z"
      fill="#FFDA44"/>
    <path
      d="M337.1 335.5L345.1 309.9L323.2 294.4L350 294L357.9 268.4L366.6 293.8L393.4 293.5L371.9 309.5L380.5 334.9L358.6 319.4L337.1 335.5Z"
      fill="#FFDA44"/>
    <path
      d="M382.4 187.9L370.6 212L389.8 230.7L363.3 226.9L351.5 250.9L346.9 224.5L320.3 220.7L344.1 208.2L339.5 181.7L358.7 200.4L382.4 187.9Z"
      fill="#FFDA44"/>
    <path
      d="M304.2 114.9L302.2 141.6L327.1 151.7L301 158.1L299.1 184.9L285 162.1L258.9 168.5L276.2 148L262 125.3L286.9 135.4L304.2 114.9Z"
      fill="#FFDA44"/>
  </svg>
{:else if countryCode === "id"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
      fill="#F0F0F0"/>
    <path d="M0 256C0 114.616 114.616 0 256 0C397.384 0 512 114.616 512 256" fill="#A2001D"/>
  </svg>
{:else if countryCode === "in"}
  <svg class="flag" width="512" height="513" viewBox="0 0 512 513" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_202_1263)">
      <path
        d="M256 512.989C397.385 512.989 512 398.374 512 256.989C512 115.604 397.385 0.989258 256 0.989258C114.615 0.989258 0 115.604 0 256.989C0 398.374 114.615 512.989 256 512.989Z"
        fill="#F0F0F0"/>
      <path
        d="M256 0.989258C154.506 0.989258 66.8099 60.0543 25.4019 145.685H486.597C445.19 60.0543 357.493 0.989258 256 0.989258Z"
        fill="#FF9811"/>
      <path
        d="M256 512.989C357.493 512.989 445.19 453.924 486.598 368.293H25.4019C66.8099 453.924 154.506 512.989 256 512.989Z"
        fill="#6DA544"/>
      <path
        d="M256 346.032C305.177 346.032 345.043 306.166 345.043 256.989C345.043 207.812 305.177 167.946 256 167.946C206.823 167.946 166.957 207.812 166.957 256.989C166.957 306.166 206.823 346.032 256 346.032Z"
        fill="#0052B4"/>
      <path
        d="M256 312.641C286.736 312.641 311.652 287.725 311.652 256.989C311.652 226.253 286.736 201.337 256 201.337C225.264 201.337 200.348 226.253 200.348 256.989C200.348 287.725 225.264 312.641 256 312.641Z"
        fill="#F0F0F0"/>
      <path
        d="M256 188.315L273.169 227.253L315.473 222.652L290.337 256.989L315.473 291.326L273.169 286.725L256 325.663L238.831 286.725L196.527 291.325L221.663 256.989L196.527 222.652L238.831 227.253L256 188.315Z"
        fill="#0052B4"/>
    </g>
    <defs>
      <clipPath id="clip0_202_1263">
        <rect width="512" height="512" fill="white" transform="translate(0 0.989258)"/>
      </clipPath>
    </defs>
  </svg>
{:else if countryCode === "my"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
      fill="#F0F0F0"/>
    <path d="M244.869 256H511.999C511.999 232.893 508.919 210.511 503.18 189.217H244.869V256Z" fill="#D80027"/>
    <path d="M244.869 122.435H474.425C458.754 96.863 438.719 74.26 415.356 55.652H244.869V122.435Z" fill="#D80027"/>
    <path d="M256 512C316.249 512 371.626 491.176 415.357 456.348H96.6426C140.374 491.176 195.751 512 256 512Z"
          fill="#D80027"/>
    <path
      d="M37.5734 389.565H474.425C487.006 369.037 496.762 346.596 503.18 322.782H8.81836C15.2354 346.596 24.9924 369.037 37.5734 389.565Z"
      fill="#D80027"/>
    <path d="M256 256C256 114.616 256 97.948 256 0C114.616 0 0 114.616 0 256H256Z" fill="#0052B4"/>
    <path
      d="M170.234 219.13C135.272 219.13 106.93 190.787 106.93 155.826C106.93 120.865 135.273 92.522 170.234 92.522C181.135 92.522 191.392 95.279 200.347 100.131C186.299 86.394 167.087 77.914 145.886 77.914C102.857 77.914 67.9727 112.797 67.9727 155.827C67.9727 198.857 102.857 233.74 145.886 233.74C167.087 233.74 186.299 225.26 200.347 211.523C191.392 216.373 181.136 219.13 170.234 219.13Z"
      fill="#FFDA44"/>
    <path
      d="M188.072 111.304L199.311 134.806L224.692 128.942L213.326 152.381L233.738 168.568L208.324 174.297L208.395 200.348L188.072 184.05L167.748 200.348L167.818 174.297L142.404 168.568L162.816 152.381L151.449 128.942L176.832 134.806L188.072 111.304Z"
      fill="#FFDA44"/>
  </svg>
{:else if countryCode === "np"}
  <svg class="flag" width="513" height="512" viewBox="0 0 513 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_202_1635)">
      <path
        d="M256.988 512C398.373 512 512.988 397.385 512.988 256C512.988 114.615 398.373 0 256.988 0C115.603 0 0.988281 114.615 0.988281 256C0.988281 397.385 115.603 512 256.988 512Z"
        fill="#F0F0F0"/>
      <path d="M511.486 283.826L511.48 283.818L511.479 283.826H511.486Z" fill="#0052B4"/>
      <path
        d="M511.478 283.826C511.478 283.824 511.479 283.822 511.479 283.818L230.734 1.33105C218.069 2.62205 205.676 4.83606 193.625 7.90506C82.8863 36.1001 0.988281 256 0.988281 256C0.988281 256 359.386 495.835 400.273 468.164C408.454 462.628 416.298 456.631 423.766 450.211L257.383 283.826H511.478Z"
        fill="#0052B4"/>
      <path
        d="M446.205 256L197.233 7.02905C84.6763 33.9461 0.988281 135.192 0.988281 256C0.988281 397.384 115.604 512 256.988 512C310.617 512 360.385 495.498 401.517 467.311L190.205 256H446.205Z"
        fill="#D80027"/>
      <path
        d="M244.461 377.993L213.196 363.287L229.845 333.008L195.895 339.503L191.593 305.205L167.946 330.43L144.299 305.205L139.996 339.503L106.047 333.007L122.696 363.287L91.4297 377.993L122.696 392.698L106.047 422.978L139.998 416.484L144.298 450.78L167.946 425.555L191.593 450.78L195.895 416.484L229.844 422.979L213.195 392.7L244.461 377.993Z"
        fill="#F0F0F0"/>
      <path
        d="M223.598 141.983L200.858 131.288L212.967 109.265L188.274 113.989L185.145 89.043L167.946 107.39L150.747 89.043L147.617 113.989L122.924 109.265L135.034 131.288L112.293 141.983L167.946 153.115L223.598 141.983Z"
        fill="#F0F0F0"/>
      <path
        d="M234.728 141.983C234.728 178.866 204.828 208.766 167.945 208.766C131.062 208.766 101.162 178.866 101.162 141.983"
        fill="#F0F0F0"/>
    </g>
    <defs>
      <clipPath id="clip0_202_1635">
        <rect width="512" height="512" fill="white" transform="translate(0.988281)"/>
      </clipPath>
    </defs>
  </svg>
{:else if countryCode === "mm"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M496.077 345.043C506.368 317.311 512 287.314 512 256C512 224.686 506.368 194.689 496.077 166.957L256 144.696L15.923 166.957C5.633 194.689 0 224.686 0 256C0 287.314 5.633 317.311 15.923 345.043L256 367.304L496.077 345.043Z"
      fill="#6DA544"/>
    <path d="M496.077 166.957C459.906 69.472 366.071 0 256 0C145.929 0 52.0939 69.472 15.9229 166.957H496.077Z"
          fill="#FFDA44"/>
    <path d="M256 512C366.071 512 459.906 442.528 496.077 345.043H15.9229C52.0939 442.528 145.929 512 256 512Z"
          fill="#D80027"/>
    <path
      d="M431.549 216.586H297.442L256 89.043L214.558 216.586H80.4512L188.946 295.412L147.504 422.957L256 345.043L364.496 422.956L323.055 295.411L431.549 216.586Z"
      fill="#F0F0F0"/>
  </svg>
{:else if countryCode === "pk"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
      fill="#F0F0F0"/>
    <path d="M0 256C0 353.035 53.989 437.454 133.565 480.873V31.127C53.989 74.546 0 158.965 0 256Z" fill="#F0F0F0"/>
    <path
      d="M256 0C211.65 0 169.936 11.283 133.565 31.127V480.872C169.936 500.717 211.65 512 256 512C397.384 512 512 397.384 512 256C512 114.616 397.384 0 256 0Z"
      fill="#496E2D"/>
    <path
      d="M365.453 298.337C333.066 321.738 287.84 314.454 264.44 282.068C241.038 249.68 248.323 204.455 280.71 181.055C290.808 173.759 302.154 169.446 313.697 167.947C291.49 164.626 268.015 169.63 248.378 183.819C208.518 212.621 199.551 268.282 228.352 308.144C257.153 348.003 312.815 356.971 352.677 328.167C372.316 313.978 384.437 293.265 388.255 271.136C383.209 281.622 375.552 291.04 365.453 298.337Z"
      fill="#F0F0F0"/>
    <path
      d="M364.067 166.959L382.311 186.62L406.647 175.348L393.584 198.772L411.827 218.435L385.511 213.25L372.449 236.676L369.248 210.046L342.932 204.861L367.269 193.589L364.067 166.959Z"
      fill="#F0F0F0"/>
  </svg>
{:else if countryCode === "ph"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
      fill="#F0F0F0"/>
    <path
      d="M256 0V256L74.9805 437.02C121.307 483.346 185.307 512 256 512C397.384 512 512 397.384 512 256C512 114.616 256 0 256 0Z"
      fill="#D80027"/>
    <path
      d="M256 0C185.307 0 121.307 28.654 74.9805 74.98C137.79 137.79 160.087 160.088 256 256H512C512 114.616 397.384 0 256 0Z"
      fill="#0052B4"/>
    <path
      d="M175.291 256L144.027 241.294L160.676 211.015L126.726 217.51L122.424 183.213L98.7757 208.437L75.1287 183.213L70.8257 217.51L36.8767 211.014L53.5257 241.294L22.2607 256L53.5257 270.706L36.8767 300.985L70.8287 294.491L75.1277 328.787L98.7757 303.563L122.424 328.787L126.726 294.491L160.674 300.986L144.026 270.707L175.291 256Z"
      fill="#FFDA44"/>
    <path
      d="M68.2728 100.174L78.6768 114.717L95.7218 109.318L85.1038 123.706L95.5078 138.249L78.5418 132.598L67.9248 146.985L68.0578 129.105L51.0928 123.453L68.1408 118.054L68.2728 100.174Z"
      fill="#FFDA44"/>
    <path
      d="M68.2728 365.015L78.6768 379.558L95.7218 374.158L85.1038 388.547L95.5078 403.09L78.5418 397.439L67.9248 411.826L68.0578 393.946L51.0928 388.294L68.1408 382.895L68.2728 365.015Z"
      fill="#FFDA44"/>
    <path
      d="M216.666 232.595L206.263 247.138L189.217 241.737L199.835 256.126L189.431 270.67L206.397 265.018L217.015 279.405L216.881 261.526L233.846 255.874L216.799 250.475L216.666 232.595Z"
      fill="#FFDA44"/>
  </svg>
{:else if countryCode === "lk"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_202_2084)">
      <path d="M0.001 44.5225H0V467.477H0.001V256.001V44.5225Z" fill="#FF9811"/>
      <path
        d="M255.999 511.998C397.383 511.998 511.998 397.383 511.998 255.999C511.998 114.615 397.383 0 255.999 0C114.615 0 0 114.615 0 255.999C0 397.383 114.615 511.998 255.999 511.998Z"
        fill="#FFDA44"/>
      <path
        d="M200.349 44.5225H111.714C107.786 47.2075 103.942 50.0025 100.175 52.8955L77.9141 255.999L100.175 459.103C103.942 461.997 107.786 464.792 111.714 467.476H200.349V44.5225Z"
        fill="#FF9811"/>
      <path
        d="M0.000976562 256.001C0.000976562 338.746 39.269 412.309 100.175 459.105V52.8965C39.269 99.6945 0.000976562 173.256 0.000976562 256.001Z"
        fill="#6DA544"/>
      <path d="M411.826 156.064V162.469L412.064 162.505L411.826 156.064Z" fill="#FFDA44"/>
      <path
        d="M491.595 322.782H443.362L422.957 345.043V389.565H378.435V367.304H400.696V322.782H300.522V350.608H278.261V297.577C271.431 291.463 267.131 282.582 267.131 272.695V128C267.131 109.559 282.081 94.6095 300.522 94.6095V300.522H345.044L360.32 287.791C357.652 281.436 356.174 274.457 356.174 267.131V233.74H322.783V166.958H389.565C389.565 155.828 406.261 144.697 406.261 144.697C406.261 144.697 422.957 155.827 422.957 166.958V183.654V233.741C435.34 233.888 455.014 233.567 476.269 233.741C470.685 223.981 467.478 212.4 467.478 200.35C467.478 180.709 475.958 163.051 489.456 150.831C470 107.716 438.954 70.9545 400.287 44.5225H233.74V467.478H400.288C447.307 435.337 483.056 387.926 500.4 332.388L491.595 322.782Z"
        fill="#A2001D"/>
    </g>
    <defs>
      <clipPath id="clip0_202_2084">
        <rect width="511.999" height="511.999" fill="white"/>
      </clipPath>
    </defs>
  </svg>
{:else if countryCode === "th"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_202_2181)">
      <path
        d="M256 512.001C397.385 512.001 512 397.386 512 256.001C512 114.616 397.385 0.000976562 256 0.000976562C114.615 0.000976562 0 114.616 0 256.001C0 397.386 114.615 512.001 256 512.001Z"
        fill="#F0F0F0"/>
      <path
        d="M496.077 166.958H15.923C5.632 194.691 0 224.687 0 256.001C0 287.315 5.632 317.311 15.923 345.044H496.078C506.368 317.311 512 287.315 512 256.001C512 224.687 506.368 194.691 496.077 166.958Z"
        fill="#0052B4"/>
      <path
        d="M256 0.000976562C178.409 0.000976562 108.886 34.525 61.9395 89.044H450.06C403.114 34.525 333.591 0.000976562 256 0.000976562Z"
        fill="#D80027"/>
      <path
        d="M450.061 422.958H61.9395C108.886 477.477 178.409 512.001 256 512.001C333.591 512.001 403.114 477.477 450.061 422.958Z"
        fill="#D80027"/>
    </g>
    <defs>
      <clipPath id="clip0_202_2181">
        <rect width="512" height="512" fill="white" transform="translate(0 0.000976562)"/>
      </clipPath>
    </defs>
  </svg>

{:else if countryCode === "vn"}
  <svg class="flag" width="512" height="512" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z"
      fill="#D80027"/>
    <path
      d="M256 133.565L283.628 218.594H373.033L300.702 271.144L328.33 356.174L256 303.623L183.67 356.174L211.298 271.144L138.968 218.594H228.372L256 133.565Z"
      fill="#FFDA44"/>
  </svg>
{/if}
